import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GroupWord } from 'src/app/group-word/interfaces/GroupWord.interface';
import { Frequency } from '../interfaces/Frequency';
import { FrequencyService } from '../services/frequency.service';

@Component({
  selector: 'app-frequency-view',
  templateUrl: './frequency-view.component.html',
  styleUrls: ['./frequency-view.component.css'],
})
export class FrequencyViewComponent implements OnInit {
  id: number;
  frequency: GroupWord;

  constructor(
    private activatedRoute: ActivatedRoute,
    private frequencyService: FrequencyService,
    private router: Router
  ) {
    this.activatedRoute.params.subscribe((params) => {
      if (params.id) {
        this.id = params.id;
        this.getFrequency();
      }
    });
  }

  ngOnInit(): void {}

  getFrequency() {
    this.frequencyService.getById(this.id).then((res) => {
      this.frequency = res;
      console.log(res);
    });
  }

  startFrequency(groupWordId: number, groupId: number) {
    this.router.navigate(['frequencia/add'], {
      queryParams: { groupWordId, groupId },
    });
  }
}
